import apiWorker from '../apiWorker'

const contacts = {
    verify : (data) =>  apiWorker('post', `/v1/api/contacts/verify`, data, true),
}

export default contacts;